var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_6479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 28.4048H21.7266V29.1548C21.7266 29.5692 22.0482 29.9048 22.4453 29.9048H24.2422C24.6393 29.9048 24.9609 29.5692 24.9609 29.1548V28.4048H25.5C26.2938 28.4048 26.9375 27.7331 26.9375 26.9048V16.4048C26.9375 15.5765 26.2938 14.9048 25.5 14.9048V14.1548C25.5 13.7404 25.1784 13.4048 24.7812 13.4048H21.9062C21.5091 13.4048 21.1875 13.7404 21.1875 14.1548V14.9048C20.3937 14.9048 19.75 15.5765 19.75 16.4048V26.9048C19.75 27.7331 20.3937 28.4048 21.1875 28.4048ZM34.8438 34.4048H34.7858C36.1573 32.8106 37 30.711 37 28.4048C37 23.4417 33.1313 19.4048 28.375 19.4048V22.4048C31.5456 22.4048 34.125 25.0963 34.125 28.4048C34.125 31.7132 31.5456 34.4048 28.375 34.4048H16.1562C14.9654 34.4048 14 35.4121 14 36.6548C14 37.0692 14.3216 37.4048 14.7188 37.4048H36.2812C36.6784 37.4048 37 37.0692 37 36.6548C37 35.4121 36.0346 34.4048 34.8438 34.4048ZM18.6719 32.9048H28.0156C28.2142 32.9048 28.375 32.737 28.375 32.5298V31.7798C28.375 31.5726 28.2142 31.4048 28.0156 31.4048H18.6719C18.4733 31.4048 18.3125 31.5726 18.3125 31.7798V32.5298C18.3125 32.737 18.4733 32.9048 18.6719 32.9048Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_6479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "currentColor",
    transform: "translate(14 13.4048)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTests);
export default __webpack_public_path__ + "static/media/tests.63b2e43bdda00b12fac229de66b8229c.svg";
export { ForwardRef as ReactComponent };